<template>
  <header class="header">
    <div class="header__title">
      {{ $t('image.IMAGE_COLLECTION') }}
      <HelpTooltip>
        <template #title> {{ $t('image.IMAGE_COLLECTION') }} </template>
        <template #description>
          {{ $t('image.unsplash.HELP') }}
          <a
            class="user-link__text"
            href="https://unsplash.com/?utm_source=admin&utm_medium=referral"
            target="_blank"
          >
            Unsplash
          </a>
        </template>
      </HelpTooltip>
    </div>

    <ButtonClose @click="close" />
  </header>
</template>

<script>
// TODO: check admin namechange to manager for Unsplash app:
import ButtonClose from '@/components/generics/ButtonClose'
import HelpTooltip from '@/components/generics/HelpTooltip'

export default {
  components: {
    ButtonClose,
    HelpTooltip,
  },
  emits: ['onClose'],
  methods: {
    close() {
      this.$emit('onClose')
    },
  },
}
</script>

<style lang="scss" scoped>
.header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  z-index: 1;

  &__title {
    display: flex;
    align-items: center;
    gap: $spacing-5xs;
    @include subtitle;
  }
}
</style>
